import http from '@/utils/ajax'
import Router from '@/router'
import Vue from 'vue'
import clone from 'clone'
import { CLAIMS_CLAIMDETAIL_SAVE_LOADING, CLAIMS_CLAIMDETAIL_SAVE_FAIL, CLAIMS_CLAIMDETAIL_SAVE_SUCCESS, CLAIMS_CLAIMDETAIL_LOAD_DATA } from '@/store/types'

export const claim = {
  async createClaim({ commit, state }, formData) {
    // Only use this for Claim New - Convert Claim and Save
    const apiUrl = state.claimEntry.menu.convertAndSave
    if (apiUrl) {
      commit(CLAIMS_CLAIMDETAIL_SAVE_LOADING)
      try {
        const result = await http.post(apiUrl, formData)
        if (result.data) {
          const commitObject = {
            partialSave: false,
            data: result.data,
            query: false
          }
          commit(CLAIMS_CLAIMDETAIL_LOAD_DATA, commitObject)

          // Redirect to specific Claim Detail page
          Router.push({ name: 'claimDetail' })
        }
        commit(CLAIMS_CLAIMDETAIL_SAVE_SUCCESS)
      } catch (error) {
        console.log(error)
        if (error.response && error.response.data) {
          commit(CLAIMS_CLAIMDETAIL_SAVE_FAIL, formatServerSaveError(error.response.data))
        } else {
          commit(CLAIMS_CLAIMDETAIL_SAVE_FAIL, generateManualSaveError(['Fail to create Claim']))
        }
      }
    } else {
      commit(CLAIMS_CLAIMDETAIL_SAVE_FAIL, generateManualSaveError(['Invalid API URL']))
    }
  },
  async saveClaim({ commit, state, getters }) {
    // Save Claim
    const apiUrl = state.claimDetail.menu.save
    if (apiUrl) {
      commit(CLAIMS_CLAIMDETAIL_SAVE_LOADING)
      try {
        const submitForm = generateCurrentForm(state, getters)
        const result = await http.post(apiUrl, submitForm)
        if (result.data) {
          const commitObject = {
            partialSave: true,
            data: result.data,
            query: false
          }
          commit(CLAIMS_CLAIMDETAIL_LOAD_DATA, commitObject)
        }
        commit(CLAIMS_CLAIMDETAIL_SAVE_SUCCESS)
        Vue.prototype.$snotify.success('Record saved')
      } catch (error) {
        if (error.response && error.response.data) {
          commit(CLAIMS_CLAIMDETAIL_SAVE_FAIL, formatServerSaveError(error.response.data))
        } else {
          commit(CLAIMS_CLAIMDETAIL_SAVE_FAIL, generateManualSaveError(['Fail to save Claim']))
        }
        // Throw out the error, the component need to know if its success or not
        throw error
      }
    } else {
      commit(CLAIMS_CLAIMDETAIL_SAVE_FAIL, generateManualSaveError(['Invalid API URL']))
      const err = { message: 'Invalid API URL' }
      throw err
    }
  },
  async voidClaim({ commit, state, getters }) {
    const apiUrl = state.claimDetail.menu.void
    if (apiUrl) {
      commit(CLAIMS_CLAIMDETAIL_SAVE_LOADING)
      try {
        const submitForm = {
          clmRefNo: state.claimDetail.commonForm.clmRefNo,
          revision: state.claimDetail.commonForm.revision,
          appID: state.claimDetail.commonForm.appID
        }
        await http.post(apiUrl, submitForm)

        commit(CLAIMS_CLAIMDETAIL_SAVE_SUCCESS)
      } catch (error) {
        if (error.response && error.response.data) {
          commit(CLAIMS_CLAIMDETAIL_SAVE_FAIL, formatServerSaveError(error.response.data))
        } else {
          commit(CLAIMS_CLAIMDETAIL_SAVE_FAIL, generateManualSaveError(['Fail to update Claim Status to Void']))
        }
        // Throw out the error, the component need to know if its success or not
        throw error
      }
    } else {
      commit(CLAIMS_CLAIMDETAIL_SAVE_FAIL, generateManualSaveError(['Invalid API URL']))
      const err = { message: 'Invalid API URL' }
      throw err
    }
  }
}

/**
 * To put manual messages into saveError
 * @param {Array of String} msgs
 */
const generateManualSaveError = (msgs) => {
  if (msgs && msgs.length > 0) {
    return {
      fieldMessages: [],
      messages: msgs
    }
  } else {
    return {
      fieldMessages: [],
      messages: []
    }
  }
}

/**
 * Format server return object to dialog readable format
 * @param {Server return object data} data
 */
const formatServerSaveError = (data) => {
  let fieldMessages = []
  let messages = []

  if (data) {
    if (data.messages && data.messages.length > 0) {
      for (const err of data.messages) {
        messages.push(err.message)
      }
    }
    if (data.fieldMessages && data.fieldMessages.length > 0) {
      for (const err of data.fieldMessages) {
        fieldMessages.push(err.field + ': ' + err.message.message)
      }
    }
  }
  return {
    fieldMessages: fieldMessages,
    messages: messages
  }
}

function compileCommonForm(state) {
  // Compile it into a format that sync with the backend
  const cloneCommonForm = clone(state.claimDetail.commonForm)
  let result = Object.assign({}, cloneCommonForm)
  return result
}

export const generateCurrentForm = (state) => {
  let submitForm
  submitForm = generalClaimForm(state)
  return submitForm
}

export const generalClaimForm = (state) => {
  return Object.assign({}, compileCommonForm(state), clone(state.claimDetail.claimForm))
}
